module.exports = __webpack_public_path__ + "static/media/asset7.09548cf7.svg";